"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
class Constants {
}
exports.Constants = Constants;
Constants.api = {
    baseUrl: "https://api.bentley.com/imodels",
    version: "itwin-platform.v1"
};
Constants.headers = {
    accept: "Accept",
    authorization: "Authorization",
    contentType: "ContentType",
    prefer: "Prefer",
    values: {
        contentType: "application/json"
    }
};
//# sourceMappingURL=Constants.js.map